import { ThemeProvider } from 'styled-components'
import { MergedTheme } from '@/hooks/use-merged-theme'
import { OurIntlShape } from '@/i18n/typing'
import Pptx from '@/utils/export-pptx/components/pptx'
import RadarPptxGenerator from '@/utils/export-pptx/radar-pptx-generator'
import Slide from '@/utils/export-pptx/types/slide'

const exportPptx = (
  filename: string,
  slides: Slide[],
  theme: MergedTheme,
  formatMessage: OurIntlShape['formatMessage'],
  formatNumber: OurIntlShape['formatNumber'],
  options = {
    onSlideReady: (): void => {},
  },
): Promise<string> =>
  new Promise((resolve, reject) => {
    const radarPptxGenerator = new RadarPptxGenerator()

    radarPptxGenerator.render(
      <ThemeProvider theme={theme}>
        <Pptx
          formatMessage={formatMessage}
          formatNumber={formatNumber}
          slides={slides}
          onPptxReady={async (): Promise<void> => {
            try {
              const result = await radarPptxGenerator.generate(filename)
              resolve(result)
            } catch (e) {
              reject(e)
            } finally {
              radarPptxGenerator.destroy()
            }
          }}
          onSlideReady={async (slide): Promise<void> => {
            try {
              if (slide.type === 'kd') {
                const { kolInfo } = slide
                await radarPptxGenerator.addSlidePromise({
                  masterName: kolInfo.platform,
                })
              } else {
                await radarPptxGenerator.addSlidePromise()
              }

              options.onSlideReady()
            } catch (e) {
              radarPptxGenerator.destroy()
              reject(e)
            }
          }}
        />
      </ThemeProvider>,
    )
  })

export default exportPptx
